// src/constants.ts
var GLOBAL_START_EPOCH = -1;
export {
  GLOBAL_START_EPOCH
};
//# sourceMappingURL=constants.mjs.map
